/* 🤖 this file was generated by svg-to-ts */
export const matIconPlayArrow: {
  name: 'play-arrow';
  data: string;
} = {
  name: 'play-arrow',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 8.64 15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg>`
};
